export enum OurStoryLinks {
  ProductPhilosophy = '/product-philosophy',
  SupportCenter = '/support-center',
  Sustainability = '/sustainability',
  WhoWeAre = '/about',
}
